<template>
  <div class="ms-textarea ms-editor flex" :class="{disabled: disabled, 'ms-validate': isValidate}" ref="msTextarea">
    <label v-if="label" class="label">{{ label }}</label>

    <div class="flex-row border" :class="{error: errorMessage || wordNotCorrected?.length > 0, disabled: disabled}">
      <textarea
        ref="input"
        v-model="internalText"
        class="ms-textarea-item flex"
        :placeholder="placeholder"
        :disabled="disabled"
        :maxlength="maxLength"
        :rows="rows"
        :readOnly="readOnly"
        :style="styleCustom"
        v-on="listeners"
      />
      <div v-if="errorMessage" class="icon24 error error-icon" />
      <div
        class="ic-show-correct-word"
        ref="correctWordSection"
        v-if="wordNotCorrected?.length > 0"
        @click="showCorrectWordBoard($event)"
      ></div>
    </div>

    <div v-if="errorMessage" class="error-text">
      {{ errorMessage }}
    </div>
  </div>
</template>
<script>
import msBaseComponent from '@/components/base/MsBaseComponent.vue';
import {useValidateControl} from '@/setup/validateControl.js';
import {showListCorrectWord} from '@/commons/globalMessage';
import {computed, getCurrentInstance, onMounted, ref, watch} from 'vue';

export default {
  name: 'MsTextarea',
  extends: msBaseComponent,
  props: {
    styleCustom: {
      default: null,
      type: String,
    },
    /**
     * V-model bắn ra ngoài binding 2 chiều
     */
    modelValue: {
      default: null,
    },
    /**
     * Hiện thị chũ mờ ở dưới ô input
     * Created by LTDAT(22.06.2020)
     */
    placeholder: {
      default: null,
      type: [Number, String],
    },
    // class chứa icon
    icon: {
      default: null,
      type: String,
    },
    /**
     * Số dòng
     */
    rows: {
      default: 4,
      type: Number,
    },
    // ĐVThi 09/03/2021:  bổ sung Giới hạn nhập của ô input của TextArea
    maxLength: {
      default: null,
      type: Number,
    },
    contentToolTip: {
      default: null,
      type: String,
    },
    isCheckSpell: {
      type: Boolean,
      default: false,
    },
    /**
     * cho phép nhập liệu bằng giọng nói không
     * nhhoang1 15.05.2024
     */
    allowSpeechToText: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, {emit}) {
    const {proxy} = getCurrentInstance();
    const internalText = ref('');
    const focused = ref(false);
    let blurTimeout = ref(null);

    const {errorMessage, validate, isValidate, clearValidate, wordNotCorrected} = useValidateControl({props});

    onMounted(() => {
      internalText.value = props.modelValue;
    });

    const listeners = computed(() => {
      return {
        blur: e => {
          proxy.blurTimeout = setTimeout(() => {
            proxy.validate();
            proxy.onBlur(e);
          }, 150);
        },
        focus: e => {
          onFocus(e);
        },
        change: e => {
          cancelEvent(e);
          emit('change', e, internalText.value);
        },
        //HQMINH 05.04.2024: Thực hiện xử lý event phím tắt
        keydown: event => {
          switch (event.keyCode) {
            case proxy.$ms.constant.KeyCode.Enter:
              event.preventDefault();
              event.stopPropagation();
              internalText.value = (internalText.value || '') + '\n';
              break;
          }
        },
      };
    });

    // Sự kiện focus vào ô input
    const onFocus = e => {
      const me = proxy;
      focused.value = true;
    };
    // Sự kiên blur ra ngoài ô input
    const onBlur = e => {
      const me = proxy;
      focused.value = false;
      emit('blurArea', internalText.value, e);
    };
    // Reset lại giá trị về ban đầu
    const reset = () => {
      const me = proxy;
      internalText.value = null;
    };
    // Set giá trị cho ô input
    const setValue = value => {
      internalText.value = value;
    };
    const getValue = () => {
      return internalText.value;
    };

    /**
     * Hủy lan rộng event
     * nhhhoang1 29.05.2023
     */
    const cancelEvent = e => {
      if (e) {
        if (typeof e.preventDefault === 'function') {
          e.preventDefault();
        }

        if (typeof e.stopPropagation === 'function') {
          e.stopPropagation();
        }

        if (typeof e.stopImmediatePropagation === 'function') {
          e.stopImmediatePropagation();
        }
      }
    };
    watch(
      () => internalText.value,
      (newVal, oldval) => {
        emit('update:modelValue', newVal);
      },
    );
    watch(
      () => props.modelValue,
      (newVal, oldVal) => {
        setValue(newVal);
      },
      {immediate: true},
    );
    /**
     * Show form sửa lỗi chính tả
     * pntoan 23.4.2024
     */
    const showCorrectWordBoard = event => {
      const position = {
        eventEle: event,
        correctWordCallback: correctWordCallback,
        sentenceOrigin: internalText.value,
        wordNotCorrectedOrigin: wordNotCorrected.value,
      };
      showListCorrectWord(position);
    };
    const correctWordCallback = data => {
      if (data) {
        internalText.value = data.internalText;
        wordNotCorrected.value = data.wordNotCorrected;
      }
    };

    const setValInput = val => {
      internalText.value = val;
    };

    /**
     * style
     * @returns
     * nhhoang1 22.05.2024
     */
    const styleRecoderProcess = () => {
      var height = '100%',
        el = proxy.$refs['msTextarea'];

      if (el && el.offsetHeight > 0) {
        height = `${el.offsetHeight}px`;
      }

      return {
        height,
      };
    };

    return {
      errorMessage,
      validate,
      isValidate,
      clearValidate,
      internalText,
      listeners,
      focused,
      reset,
      setValue,
      wordNotCorrected,
      getValue,
      cancelEvent,
      onFocus,
      onBlur,
      showCorrectWordBoard,
      correctWordCallback,
      blurTimeout,
      setValInput,
      styleRecoderProcess,
    };
  },
};
</script>
<style lang="scss">
@import '@/assets/scss/components/MsTextArea.scss';
</style>
